import { useParams } from 'react-router-dom'
import Debug from 'debug'
import { t } from '@lingui/core/macro'
import { skipToken } from '@tanstack/react-query'

import { cn } from '@jotta/utils/css'

import { bizApi } from '../BizApi'
import { BizUserForm } from '../components/BizUserForm'
import { BizWidget } from '../widgets/BizWidget'

export const debug = Debug('jotta:biz:BizModifyUserRoute')

export function BizUserEditRoute() {
  const { username = '' } = useParams()
  const query = bizApi.user.byId.useSuspenseQuery({
    variables: username ? { username } : skipToken,
  })
  return (
    <BizWidget
      title={username ? t`Modify user` : t`Create new user`}
      className="w-full"
      bodyClassName={cn('max-w-2xl')}
    >
      <BizUserForm user={query.data} />
    </BizWidget>
  )
}
